import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProductIndividualItemPurpose } from 'api';
import { productIndividualTypeTranslation } from 'domain/productIndividual/types/types';
import { getRepairAddLink } from 'library/components/link/linkUtils';

interface SelectRepairSerialNumberDialogProps {
	open: boolean;
	onClose: () => void;
	productIndividuals: ProductIndividualItemPurpose[];
}

export const SelectRepairSerialNumberDialog = ({
	open,
	onClose,
	productIndividuals,
}: SelectRepairSerialNumberDialogProps) => {
	const { t } = useTranslation([
		'commonButton',
		'productIndividual',
		'productType',
	]);
	const [selected, setSelected] = useState('');
	const typeTranslation = productIndividualTypeTranslation(t);

	const handleSelect = () => {
		if (selected) {
			window.location.href = getRepairAddLink(selected);
		}
	};

	const handleClose = () => {
		setSelected('');
		onClose();
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			<DialogTitle>
				{t('productIndividual:select-product-individual-to-repair')}
			</DialogTitle>
			<DialogContent>
				<RadioGroup
					value={selected}
					onChange={(_, value) => setSelected(value)}>
					{productIndividuals.map(
						({ serialNumber, productCategory }) => (
							<FormControlLabel
								key={serialNumber}
								value={serialNumber}
								control={<Radio />}
								label={`${typeTranslation(productCategory)}    ${serialNumber}`}
							/>
						)
					)}
				</RadioGroup>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={handleClose}>
					{t('commonButton:cancel')}
				</Button>
				<Button
					variant="contained"
					disabled={!selected}
					onClick={handleSelect}>
					{t('commonButton:select')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
